module.exports = __webpack_public_path__ + "static/media/add.881bf388.svg";